import { createFileRoute, redirect } from '@tanstack/react-router';
import { CreateShopPage } from '@/features/onboarding/pages/create-shop-page';
import { isApiError } from '@/lib/api';
import { requireVerifiedEmail } from '@/lib/email-gate';
import { signInSearch } from '@/lib/home';
import { meQueryOptions } from '@/lib/me';

/** Self-serve signup wizard, steps 1–2. Needs an account (sign up first) but no shop yet. */
export const Route = createFileRoute('/onboarding')({
  /** `industry` / `plan` pre-select the business type and the package to try (from the sales page, through sign-up) */
  validateSearch: (s: Record<string, unknown>): { industry?: string; plan?: string; ref?: string } => ({
    industry: typeof s.industry === 'string' && s.industry ? s.industry : undefined,
    plan: typeof s.plan === 'string' && s.plan ? s.plan : undefined,
    ref: typeof s.ref === 'string' && s.ref ? s.ref : undefined,
  }),
  beforeLoad: async ({ context, location, search }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch((e: unknown) => {
      if (isApiError(e) && e.status === 401)
        throw redirect({ to: '/sign-in', search: signInSearch(location.href) });
      throw e;
    });
    // an email sign-up confirms its address first (the API refuses to open a shop before that)
    requireVerifiedEmail(me, search);
  },
  component: CreateShopPage,
});
